import { OrderSummaryHOC } from 'routes/Checkout/containers/OrderSummaryContainer';
import OrderSummary from '../components/OrderSummary';

export default OrderSummaryHOC(OrderSummary);
